import { useContext } from 'react';
import { i18n } from 'i18n';
import AuthorisationContext, { IAuthorisationContext } from './context';

export default function useAuthorisation(): IAuthorisationContext {
  const context = useContext(AuthorisationContext);
  if (context === null) {
    throw new Error(i18n._('No page context available'));
  }

  return context;
}
